import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import type { AlertColor } from '@mui/material/Alert'; // Type-only import

interface NotificationSnackbarProps {
  open: boolean;
  message: string | null;
  severity: AlertColor | undefined; // e.g., 'success', 'error', 'warning', 'info'
  handleClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  open,
  message,
  severity,
  handleClose,
}) => {
  if (!message) return null;

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000} // Auto hide after 6 seconds
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} // Position
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar; 